<script setup lang="ts">
import useBackend from '@/composition/useBackend';
import {GraphQueryNavigation} from '@hantera/portal-app';
import {Spinner, useClose} from '@hantera/design-system';
import {onMounted, ref} from 'vue';


const props = defineProps<{
  queryName: string
  query: GraphQueryNavigation
  format: 'csv' | 'xlsx'
}>();

const backend = useBackend();
const close = useClose();
const download = ref<HTMLAnchorElement>();
const controller = new AbortController();
const signal = controller.signal;
const error = ref<string | null>(null);

onMounted(async () => {
  if (!download.value) {
    console.error('Download ref not found');
    close();
    return;
  }

  try {
    var response = await backend.fetch('/export/' + props.format, {
      method: 'POST',
      body: JSON.stringify(props.query),
      signal,
    });

    if (!response.ok) {
      if (controller.signal.aborted) {
        close();
      }

      error.value = await response.text();
      return;
    }

    const blob = await response.blob();

    download.value.href = URL.createObjectURL(blob);
    download.value.download = `Hantera_${props.queryName}_${new Date().toISOString()}.${props.format}`;
    download.value.click();

    close();
  }
  catch (e) {
    if (controller.signal.aborted) {
      close();
    }

    if (e instanceof Error) {
      error.value = e.message;
    } else {
      error.value = e?.toString() ?? 'Unknown error';
    }
  }
});

function cancel() {
  controller.abort();
}


</script>

<template>

  

  <div class="query-export" v-if="!error">
    <Spinner />
    <p>This might take a while..</p>

    <button @click="cancel">Cancel</button>
    
    <a ref="download" style="display: none"></a>
  </div>
  <div v-else>
    <p class="query-export__error">{{ error }}</p>
    <button @click="close">Close</button>
  </div>

</template>

<style>
.query-export {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 2rem 2rem 2rem;
}

.query-export__error {
  color: var(--color-error);
}
</style>